"use client";

import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";
import { CompanyDiscussionsTabEnum } from "components/company/v3/menu/enums";
import AssetDiscussion from "components/discussions/AssetDiscussion";
import useEmitSignal from "components/discussions/hooks/useEmitSignal";
import { Tabs } from "components/ui/Tabs";
import EngagementStatsByTickerSymbolQuery from "lib/queries/EngagementStatsByTickerSymbolQuery";
import { MessageCircleIcon } from "lucide-react";
import { InView } from "react-intersection-observer";
import { useIntl } from "react-intl";
import { IAssetType, ISecurityCountry, ISignalType } from "types/graphqlTypes";

interface FiisDiscussionsBoxProps {
  tickerSymbol: string;
  tab: CompanyDiscussionsTabEnum;
  onChangeTab: (tab: CompanyDiscussionsTabEnum) => void;
}

export default function FiisDiscussionsBox({ tickerSymbol, tab, onChangeTab }: FiisDiscussionsBoxProps) {
  const issuer = useBrazilianRealEstateFundIssuer();
  const intl = useIntl();
  const { emitSignal } = useEmitSignal();

  return (
    <CompanyContainer className="items-center xl:h-full">
      <CompanyContentContainer>
        <Tabs
          defaultValue={CompanyDiscussionsTabEnum.COMMENTS}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyDiscussionsTabEnum)}
          className="w-full"
        >
          <CompanyTabsList
            activeTab={tab}
            tabs={[
              {
                value: CompanyDiscussionsTabEnum.COMMENTS,
                label: intl.formatMessage({
                  defaultMessage: "Discussões",
                  description: "Aba do menu superior da empresa",
                  id: "d0ZYTR",
                }),
                icon: <MessageCircleIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />

          <CompanyTabsContent value={CompanyDiscussionsTabEnum.COMMENTS} className="p-0">
            <InView
              delay={400}
              className="h-full w-full"
              onChange={(inView) => {
                if (inView) {
                  emitSignal(
                    ISignalType.ReadIssuerComments,
                    {
                      issuerId: issuer._id,
                    },
                    [
                      {
                        query: EngagementStatsByTickerSymbolQuery,
                        variables: {
                          tickerSymbol,
                          country: ISecurityCountry.Br,
                        },
                      },
                    ],
                  );
                }
              }}
            >
              <AssetDiscussion
                hideHeaderLine={true}
                assetType={IAssetType.BrazilianRealEstateFund}
                assetId={issuer._id}
              />
            </InView>
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
